<template>
  <div class="publisher-performance-report">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
      <svg class="icon" aria-hidden="true" style="fill: #fff">
        <use xlink:href="#icon-shangpin"></use>
      </svg>
    </breadcrumbs>
    <!-- <noticeTool /> -->
    <a-spin :spinning="spinning">
      <div class="content-main" ref="mainRef">
        <div class="content-head">
          <div class="content-head-left">
            <artmisads-segmented-tabs
              v-model="activeTab"
              :items="programConfig"
            />
            <p>
              <span v-if="tagNumParams.lastUpdateAt">
                Last Update at:
                {{
                  moment(tagNumParams.lastUpdateAt).format('YYYY-MM-DD hh:mm')
                }}
              </span>
            </p>
          </div>
          <a-dropdown :getPopupContainer="() => mainRef">
            <template #overlay>
              <artmisads-dropdown-menu @click="handleExportClick">
                <a-menu-item key="all">Export All Data</a-menu-item>
                <a-menu-item key="filter">Export with Filters</a-menu-item>
              </artmisads-dropdown-menu>
            </template>
            <artmisads-button-special class="export-btn">
              <svg class="icon daochu" aria-hidden="true">
                <use xlink:href="#icon-daochu"></use>
              </svg>
              <span class="btn-text">Export</span>
              <svg class="icon artmisads-select-down-icon" aria-hidden="true">
                <use xlink:href="#icon-jiantou-xia-cu"></use>
              </svg>
            </artmisads-button-special>
          </a-dropdown>
        </div>
        <filterBar
          pageType="sellerPerformance"
          :params="params"
          :getList="getList"
          :setParams="setParams"
          :dateParams="[
            params.startReportDateTimestamp,
            params.endReportDateTimestamp,
          ]"
          platform="publisher"
        />
        <div class="tags">
          <filterTag
            :naList="naList"
            :setParams="setParams"
            :tagNumParams="tagNumParams"
            :marketplace="params.marketplace"
            :defaultMetricName="defaultMetricName"
            :noNeedList="noNeedList"
          />
        </div>

        <div class="content">
          <p>{{ RESPORTS_TYPE_MAP[params.metricName].name }}</p>
          <div class="chart">
            <chart
              :dataList="dataList"
              :width="chartWidth"
              showYName="metricValue"
              showXName="reportDateTimestamp"
              :lineColor="chartParams.lineColor"
              :isPercent="params.metricName === 'conversionsRate'"
              :lineBgOffsetTop="chartParams.lineBgOffsetTop"
              :lineBgOffsetZero="chartParams.lineBgOffsetZero"
              chartType="line"
              :selectDaysNum="selectDaysNum"
              :showCurrent="false"
              :defaultMetricName="defaultMetricName"
              :startTimestamp="params.startReportDateTimestamp"
              :endTimestamp="params.endReportDateTimestamp"
              :metricName="params.metricName"
            />
          </div>
          <div class="table">
            <tableContent
              :dataList="tableList"
              :tableNaKeys="naList"
              :activeTab="activeTab"
              :marketplace="params.marketplace"
              :tableTotal="tableTotal"
              :params="tableParams"
              :setParams="setTableParams"
              :tagNumParams="tagNumParams"
            />
          </div>
        </div>
      </div>
    </a-spin>
  </div>
</template>
<script setup>
import { computed, onMounted, ref, watch, nextTick } from 'vue'
import moment from 'moment'

import { publisherReportsApi } from '~/server/index'
import { RESPORTS_TYPE_MAP } from '../../../../contants/reports'
import breadcrumbs from '~/components/breadcrumbs.vue'
import filterBar from '~/components/reports/filterBar.vue'
import filterTag from '~/components/reports/filterTag.vue'
import noticeTool from '~/components/reports/noticeTool.vue'
import chart from '~/components/reports/chart.vue'
import tableContent from './tableContent.vue'
import { useSystemStore } from '@/storeData/system'

const systemStore = useSystemStore()
const activeTab = ref('0')
const programConfig = computed(() => {
  const src = systemStore.programConfig || []
  const tabs = src.map((item) => ({ ...item }))
  // 仅 Performance 页单独追加 Creator Connections
  if (!tabs.some((item) => item.key === '2')) {
    tabs.push({
      key: '2',
      label: 'Creator Connections',
      disabled: false,
    })
  }
  return tabs
})
const isResetting = ref(false)
const noNeedList = ref([
  'orders',
  'acosAmount',
  'salesAmount',
  'bonusAmount',
  'commissionAndFeeAmount',
  'quantity',
  'finalCommissionAndFeeAmount',
  'finalCommissionAmount',
])
const breadcrumbsData = {
  title: 'Performance Reports',
  color: '#4682FA',
  // hasTitleIcon:true,
  links: [
    {
      name: 'Home',
      path: '/publisher/dashboard',
    },
    {
      name: 'Reports',
      path: '/publisher/reports/performance',
    },
    {
      name: 'Performance',
      path: '/publisher/reports/performance',
    },
  ],
}
const chartWidth = ref(1092)
const spinning = ref(false)
const dataList = ref([])
const mainRef = ref()
const naList = ref([]) // filter tag显示N/A列表
const defaultMetricName = ref('clicks')
const params = ref({
  marketplace: 'amazon.com',
  startReportDateTimestamp: moment()
    .subtract(30, 'day')
    .startOf('day')
    .valueOf(),
  endReportDateTimestamp: moment().startOf('day').valueOf(),
  brandId: null,
  productId: null,
  metricName: 'clicks',
  asin: null,
})
const tableList = ref([])
const tableTotal = ref(0)
const tableParams = ref({
  page: 1,
  size: 200,
  sortDirection: '',
  sortField: '',
})

const tagNumParams = ref({
  totalClicks: null,
  totalDetailPageViews: null,
  totalAddToCart: null,
  totalConversions: null,
  totalConversionsRate: null,
  totalSalesAmount: null,
  totalDiscountedSalesAmount: null,
  totalBonusAmount: null,
  totalCommissionAmount: null,
  totalFinalCommissionAmount: null,
  lastUpdateAt: null,
})

const selectDaysNum = computed(() => {
  const { endReportDateTimestamp, startReportDateTimestamp } = params.value
  const intervalDays = moment(endReportDateTimestamp).diff(
    moment(startReportDateTimestamp),
    'days',
  )
  return intervalDays
})

const chartParams = computed(() => {
  let lineColor,
    lineBgOffsetTop,
    lineBgOffsetZero,
    isPercent,
    chartParamsData,
    itemData
  itemData = RESPORTS_TYPE_MAP[params.value.metricName]
  lineColor = itemData.lineColor
  lineBgOffsetTop = itemData.lineBgOffsetTop
  lineBgOffsetZero = itemData.lineBgOffsetZero
  isPercent = params.value.metricName === 'commission'
  chartParamsData = { lineColor, lineBgOffsetTop, lineBgOffsetZero, isPercent }
  return chartParamsData
})

const getChartWidth = () => {
  const $chart = document.querySelector('.chart')
  const widthNum = $chart.clientWidth - 20
  chartWidth.value = widthNum
}

const setTableParams = (obj) => {
  const newObj = { ...tableParams.value, ...obj }
  tableParams.value = newObj
}

const setParams = (obj) => {
  const newObj = { ...params.value, ...obj }
  setTableParams({ page: 1 })
  params.value = newObj
}

watch(
  params,
  async (newValue, oldValue) => {
    if (isResetting.value) {
      return
    }

    if (newValue.metricName !== oldValue.metricName) {
      switch (activeTab.value) {
        case '0':
          spinning.value = true
          await getList()
          spinning.value = false
          break
        case '1':
          spinning.value = true
          await getListAssociate()
          spinning.value = false
          break
        case '2':
          spinning.value = true
          await getListCc()
          spinning.value = false
          break
      }
    } else {
      if (activeTab.value === '0') {
        if (newValue.brandId || newValue.asin) {
          naList.value = ['clicks']
          newValue.metricName = 'detailPageViews'
          defaultMetricName.value = 'detailPageViews'
        } else {
          naList.value = []
          newValue.metricName = 'clicks'
          defaultMetricName.value = 'clicks'
        }
      }

      switch (activeTab.value) {
        case '0':
          getAllData()
          break
        case '1':
          getAllDataAssociate()
          break
        case '2':
          getAllDataCc()
          break
      }
    }
  },
  { deep: true, flush: 'post' },
)

watch(
  tableParams,
  async (newValue, oldValue) => {
    if (isResetting.value) return
    const hasChanged = Object.keys(newValue).some(
      (key) => newValue[key] !== oldValue[key],
    )
    if (hasChanged) {
      switch (activeTab.value) {
        case '0':
          spinning.value = true
          await getTableList()
          spinning.value = false
          break
        case '1':
          spinning.value = true
          await getTableListAssociate()
          spinning.value = false
          break
        case '2':
          spinning.value = true
          await getTableListCc()
          spinning.value = false
          break
      }
    }
  },
  { deep: true, flush: 'post' },
)

watch(activeTab, async () => {
  await reserParams()
  await reserTableParams()
  switch (activeTab.value) {
    case '0':
      noNeedList.value = [
        'orders',
        'acosAmount',
        'salesAmount',
        'bonusAmount',
        'commissionAndFeeAmount',
        'quantity',
        'finalCommissionAndFeeAmount',
        'finalCommissionAmount',
      ]
      if (params.value.brandId || params.value.asin) {
        naList.value = ['clicks']
        defaultMetricName.value = 'detailPageViews'
      } else {
        naList.value = []
        defaultMetricName.value = 'clicks'
      }
      getAllData()
      break
    case '1':
      noNeedList.value = [
        'clicks',
        'detailPageViews',
        'addToCart',
        'conversions',
        'orders',
        'conversionsRate',
        'acosAmount',
        'discountedSalesAmount',
        'bonusAmount',
        'commissionAndFeeAmount',
        'finalCommissionAndFeeAmount',
      ]
      naList.value = []
      defaultMetricName.value = 'quantity'
      getAllDataAssociate()
      break
    case '2':
      noNeedList.value = [
        'detailPageViews',
        'addToCart',
        'conversions',
        'conversionsRate',
        'quantity',
        'acosAmount',
        'discountedSalesAmount',
        'commissionAndFeeAmount',
        'commissionAmount',
        'finalCommissionAndFeeAmount',
        'finalCommissionAmount',
      ]
      naList.value = []
      defaultMetricName.value = 'clicks'
      getAllDataCc()
      break
  }
})
const getAllData = async () => {
  spinning.value = true
  try {
    const results = await Promise.allSettled([
      getList(),
      getTableList(),
      getPublisherCommissionReportsAgg(),
    ])

    // 检查是否有失败的请求
    const failedResults = results.filter(
      (result) => result.status === 'rejected',
    )
    if (failedResults.length > 0) {
      console.error('部分请求执行失败:', failedResults)
    }
  } catch (error) {
    console.error('请求执行失败:', error)
  } finally {
    spinning.value = false
  }
}
const getAllDataAssociate = async () => {
  spinning.value = true
  try {
    const results = await Promise.allSettled([
      getListAssociate(),
      getTableListAssociate(),
      getPublisherCommissionReportsAggAssociate(),
    ])

    // 检查是否有失败的请求
    const failedResults = results.filter(
      (result) => result.status === 'rejected',
    )
    if (failedResults.length > 0) {
      console.error('部分请求执行失败:', failedResults)
    }
  } catch (error) {
    console.error('请求执行失败:', error)
  } finally {
    spinning.value = false
  }
}
const reserParams = async () => {
  isResetting.value = true

  nextTick(() => {
    params.value = {
      marketplace: 'amazon.com',
      startReportDateTimestamp: moment()
        .subtract(30, 'day')
        .startOf('day')
        .valueOf(),
      endReportDateTimestamp: moment().startOf('day').valueOf(),
      brandId: null,
      productId: null,
      metricName:
        activeTab.value === '0'
          ? params.value.brandId || params.value.asin
            ? 'detailPageViews'
            : 'clicks'
          : activeTab.value === '1'
            ? 'quantity'
            : 'clicks',
      asin: null,
    }
    nextTick(() => {
      isResetting.value = false
    })
  })
}

const reserTableParams = async () => {
  isResetting.value = true
  nextTick(() => {
    tableParams.value = {
      page: 1,
      size: 200,
      sortDirection: '',
      sortField: '',
    }
    nextTick(() => {
      isResetting.value = false
    })
  })
}

const getList = async () => {
  let newparams = { ...params.value }
  const res =
    await publisherReportsApi.getPublisherCommissionReportsPerformanceDailyMetric(
      newparams,
    )
  const { success, data } = res
  if (success) {
    dataList.value =
      newparams.metricName === 'conversionsRate'
        ? data.map((item) => {
            return {
              ...item,
              metricValue: (item.metricValue * 100)
                .toFixed(2)
                .replace(/(\.\d*?[1-9])0+$|\.0+$/, '$1'),
            }
          })
        : data
  }
}

const getTableList = async () => {
  let newparams = { ...params.value, ...tableParams.value }
  const res =
    await publisherReportsApi.getPublisherCommissionReportsPerformance(
      newparams,
    )
  const { success, data } = res
  if (success) {
    tableList.value = data.data
    tableTotal.value = data.total
  }
}

const getPublisherCommissionReportsAgg = async () => {
  const res = await publisherReportsApi.getPublisherCommissionReportsAgg(
    params.value,
  )
  const { success, data } = res
  if (success) {
    tagNumParams.value = data
  }
}

const handleExportClick = async ({ key }) => {
  let exportParams = {
      endReportDateTimestamp: moment().startOf('day').valueOf(),
      marketplace: params.value.marketplace,
      startReportDateTimestamp: moment()
        .subtract(1825, 'day')
        .startOf('day')
        .valueOf(),
    },
    newExportParams = {}

  if (key === 'filter') {
    exportParams = { ...params.value }
  }
  for (let item in exportParams) {
    if (exportParams[item]) {
      newExportParams[item] = exportParams[item]
    }
  }
  const finalParams = {
    qs: newExportParams,
    fileName: `Performance-Reports-${moment().format('YYYY-MM-DD')}.csv`,
  }
  switch (activeTab.value) {
    case '0':
      finalParams.fileName = `Performance-Reports-Attribution-${moment().format(
        'YYYY-MM-DD',
      )}.csv`
      publisherReportsApi.exportCommissionPerformanceReports(finalParams)
      break
    case '1':
      finalParams.fileName = `Performance-Reports-Associate-${moment().format(
        'YYYY-MM-DD',
      )}.csv`
      publisherReportsApi.exportCommissionPerformanceReportsAssociate(
        finalParams,
      )
      break
    case '2':
      finalParams.fileName = `Performance-Reports-CreatorConnections-${moment().format(
        'YYYY-MM-DD',
      )}.csv`

      publisherReportsApi.exportCommissionPerformanceReportsCc(finalParams)
      break
  }
}

// Associate API functions
const getListAssociate = async () => {
  spinning.value = true
  let newparams = { ...params.value }
  const res =
    await publisherReportsApi.getPublisherCommissionReportsPerformanceDailyMetricAssociate(
      newparams,
    )
  const { success, data } = res
  if (success) {
    dataList.value =
      newparams.metricName === 'conversionsRate'
        ? data.map((item) => {
            return {
              ...item,
              metricValue: (item.metricValue * 100)
                .toFixed(2)
                .replace(/(\.\d*?[1-9])0+$|\.0+$/, '$1'),
            }
          })
        : data
  }
  spinning.value = false
}

const getTableListAssociate = async () => {
  spinning.value = true
  let newparams = { ...params.value, ...tableParams.value }
  const res =
    await publisherReportsApi.getPublisherCommissionReportsPerformanceAssociate(
      newparams,
    )
  const { success, data } = res
  if (success) {
    tableList.value = data.data
    tableTotal.value = data.total
  }
  spinning.value = false
}

const getPublisherCommissionReportsAggAssociate = async () => {
  spinning.value = true
  const res =
    await publisherReportsApi.getPublisherCommissionReportsAggAssociate(
      params.value,
    )
  const { success, data } = res
  if (success) {
    tagNumParams.value = data
  }
  spinning.value = false
}

const getListCc = async () => {
  const newparams = { ...params.value }
  const res =
    await publisherReportsApi.getPublisherCommissionReportsPerformanceDailyMetricCc(
      newparams,
    )
  const { success, data } = res
  if (success) {
    dataList.value = data
  }
}

const getTableListCc = async () => {
  const newparams = { ...params.value, ...tableParams.value }
  const res =
    await publisherReportsApi.getPublisherCommissionReportsPerformanceCc(
      newparams,
    )
  const { success, data } = res
  if (success) {
    tableList.value = data.data
    tableTotal.value = data.total
  }
}

const getPublisherCommissionReportsAggCc = async () => {
  const res = await publisherReportsApi.getPublisherCommissionReportsAggCc(
    params.value,
  )
  const { success, data } = res
  if (success) {
    tagNumParams.value = {
      ...data,
      totalOrders: data.totalOrders ?? data.totalConversions ?? 0,
      totalClicks: data.totalClicks ?? 0,
    }
  }
}

const getAllDataCc = async () => {
  spinning.value = true
  try {
    const results = await Promise.allSettled([
      getListCc(),
      getTableListCc(),
      getPublisherCommissionReportsAggCc(),
    ])

    const failedResults = results.filter(
      (result) => result.status === 'rejected',
    )
    if (failedResults.length > 0) {
      console.error('部分请求执行失败:', failedResults)
    }
  } catch (error) {
    console.error('请求执行失败:', error)
  } finally {
    spinning.value = false
  }
}

onMounted(async () => {
  getChartWidth()

  // 使用 Promise.allSettled 并行执行请求，提高性能
  spinning.value = true
  try {
    const results = await Promise.allSettled([
      getList(),
      getTableList(),
      getPublisherCommissionReportsAgg(),
    ])

    // 检查是否有失败的请求
    const failedResults = results.filter(
      (result) => result.status === 'rejected',
    )
    if (failedResults.length > 0) {
      console.error('部分请求执行失败:', failedResults)
    }
  } catch (error) {
    console.error('请求执行失败:', error)
  } finally {
    spinning.value = false
  }

  window.addEventListener('resize', function () {
    getChartWidth()
  })
})
</script>
<style lang="less" scoped>
.publisher-performance-report {
  .content-main {
    border-radius: 12px;
    overflow: hidden;
    border-radius: 12px;
    background-color: var(--color-white);
    box-shadow: var(--section-box-shadow-6);
    .tags {
      padding: 20px 12px;
    }
    .content-head {
      display: flex;
      justify-content: space-between;
      height: 64px;
      padding-left: 16px;
      padding-right: 16px;
      .content-head-left {
        display: flex;
        align-items: center;
        > p {
          font-size: 14px;
          color: var(--dark-2);
          line-height: 19px;
          align-self: center;
          margin-left: 20px;
        }
      }
      > button {
        align-self: center;
        cursor: pointer;
        display: flex;
        .jiantou {
          width: 16px;
          height: 16px;
          fill: var(--dark-3);
          margin-left: 8px;
        }
        .daochu {
          width: 20px;
          height: 20px;
          margin-right: 8px;
          fill: var(--dark-1);
        }
        > svg {
          align-self: center;
        }
        > span {
          align-self: center;
        }
        .btn-text {
          align-self: center;
          font-weight: 500;
          line-height: 20px;
          margin-right: 8px;
        }
      }
    }
  }
  .content {
    padding: 16px;

    .table {
      margin-top: 40px;
    }
    .chart {
      padding: 0 10px;
    }
    > p {
      font-weight: 600;
      font-size: 20px;
      color: var(--dark-1);
      letter-spacing: 0.5px;
      line-height: 28px;
      margin-bottom: 30px;
    }
  }
}
</style>
